import { render, staticRenderFns } from "./pgcRecord.vue?vue&type=template&id=962b3c50&scoped=true"
import script from "./pgcRecord.vue?vue&type=script&lang=js"
export * from "./pgcRecord.vue?vue&type=script&lang=js"
import style0 from "./pgcRecord.vue?vue&type=style&index=0&id=962b3c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962b3c50",
  null
  
)

export default component.exports